import React, { Component } from 'react';
import { Form, Row, Col } from 'react-bootstrap';
import { FormControl } from '../../../facturotopia';
import Validator from 'validatorjs';

class PacUpsertForm extends Component {
  state = {};

  constructor(props) {
    super(props);

    this.state = {
      validator: new Validator({}, this.rules),
    };
  }

  get rules() {
    return {
      nombre: ['required'],
      alias: ['required'],
    };
  }

  validate(data) {
    const validator = new Validator(data, this.rules);

    validator.check();

    this.setState({
      validator,
    });

    return validator;
  }

  handleOnChange = (value) => {
    const { step } = this.props;
    const data = {
      ...this.props.data,
      status: undefined,
      ...value,
    };

    const validator = this.validate(data);

    this.props.onFormDataChange({
      data,
      step,
      isValid: validator.passes(),
    });
  };

  handleOnComplementosChange = (value) => {
    const name = Object.keys(value)[0];
    const _value = Object.values(value)[0];

    const {
      step,
      data: { config = {} },
    } = this.props;

    const data = {
      ...this.props.data,
      status: undefined,
      ...value,
      config: {
        ...config,
        [name]: _value
          .split(',')
          .map((item) => item.trim())
          .filter((item) => !!item),
      },
    };

    const validator = this.validate(data);

    this.props.onFormDataChange({
      data,
      step,
      valid: validator.passes(),
    });
  };

  handleOnConfigChange = (event) => {
    const { name, checked } = event.target;
    const {
      data: { config = {} },
    } = this.props;

    this.handleOnChange({
      config: {
        ...config,
        [name]: checked,
      },
    });
  };

  handleOnTimbradoConfigChange = (event) => {
    const name = event.target.name;

    const {
      data: { config = {} },
    } = this.props;

    const { timbrado = [] } = config;

    let newTimbradoConfig = [];

    if (timbrado.includes(name)) {
      newTimbradoConfig = timbrado.filter((item) => {
        return item !== name;
      });
    } else {
      newTimbradoConfig = timbrado.concat(name);
    }

    this.handleOnChange({
      config: {
        ...config,
        timbrado: newTimbradoConfig,
      },
    });
  };

  handleOnCancellationConfigChange = (event) => {
    const { name } = event.target;
    const {
      data: { config = {} },
    } = this.props;

    const { cancelacion = [] } = config;

    let newCancelacionConfig = [];

    if (cancelacion.includes(name)) {
      newCancelacionConfig = cancelacion.filter((item) => {
        return item !== name;
      });
    } else {
      newCancelacionConfig = cancelacion.concat(name);
    }

    this.handleOnChange({
      config: {
        ...config,
        cancelacion: newCancelacionConfig,
      },
    });
  };

  render() {
    const {
      data = {},
      data: { config = {} },
    } = this.props;

    const { validator } = this.state;

    const { timbrado = [], cancelacion = [] } = config;

    return (
      <Form autoComplete="off">
        <Row>
          <Col
            xs={12}
            sm={12}
            md={6}
            lg={5}
          >
            <FormControl
              type="text"
              label="Proveedor"
              name="nombre"
              placeholder=""
              help="Nombre comercial"
              validator={validator}
              autoFocus={true}
              value={data.nombre}
              onChange={this.handleOnChange}
            />

            <FormControl
              type="text"
              label="Alias"
              name="alias"
              placeholder=""
              help="Para uso en el pool de Proveedores"
              validator={validator}
              value={data.alias}
              readOnly={!!data.id}
              onChange={this.handleOnChange}
            />

            <FormControl
              type="text"
              label="Costo hit"
              name="costo_timbre"
              placeholder=""
              validator={validator}
              value={data.costo_timbre}
              onChange={this.handleOnChange}
            />
          </Col>

          <Col
            xs={12}
            sm={12}
            md={6}
            lg={5}
          >
            <Form.Group controlId="registro_emisores">
              <strong>Servicios</strong>
            </Form.Group>

            <Form.Group controlId="registro_emisores">
              <Form.Check
                type="checkbox"
                name="registro_emisores"
                label="Registro de emisores"
                checked={config.registro_emisores || false}
                onChange={this.handleOnConfigChange}
              />
            </Form.Group>

            <Form.Group controlId="manifiesto">
              <Form.Check
                type="checkbox"
                name="manifiesto"
                label="Servicio de manifiesto"
                checked={config.manifiesto || false}
                onChange={this.handleOnConfigChange}
              />
            </Form.Group>

            <Form.Group controlId="timbrado">
              <strong>Timbrado</strong>

              <Form.Group controlId="timbrado_comprobantes">
                <Form.Check
                  type="checkbox"
                  name="comprobantes"
                  label="Timbrado Comprobantes"
                  checked={timbrado.includes('comprobantes')}
                  onChange={this.handleOnTimbradoConfigChange}
                />
              </Form.Group>
            </Form.Group>

            <Form.Group controlId="timbrado_retenciones">
              <Form.Check
                type="checkbox"
                name="retenciones"
                label="Timbrado Retenciones"
                checked={timbrado.includes('retenciones')}
                onChange={this.handleOnTimbradoConfigChange}
              />
            </Form.Group>

            <Form.Group controlId="timbrado_sector_primario">
              <Form.Check
                type="checkbox"
                name="sector_primario"
                label="Timbrado Sector Primario"
                checked={timbrado.includes('sector_primario')}
                onChange={this.handleOnTimbradoConfigChange}
              />
            </Form.Group>

            <Form.Group controlId="cancelaciones">
              <strong>Cancelaciones</strong>
            </Form.Group>

            <Form.Group controlId="comprobantes">
              <Form.Check
                type="checkbox"
                name="comprobantes"
                label="Cancelación de comprobantes"
                checked={cancelacion.includes('comprobantes')}
                onChange={this.handleOnCancellationConfigChange}
              />
            </Form.Group>

            <Form.Group controlId="comprobantes_con_aceptacion">
              <Form.Check
                type="checkbox"
                name="comprobantes_con_aceptacion"
                label="Cancelación de comprobantes con aceptación"
                checked={cancelacion.includes('comprobantes_con_aceptacion')}
                onChange={this.handleOnCancellationConfigChange}
              />
            </Form.Group>

            <Form.Group controlId="c_sector_primario">
              <Form.Check
                type="checkbox"
                name="sector_primario"
                label="Cancelación de sector primario"
                checked={cancelacion.includes('sector_primario')}
                onChange={this.handleOnCancellationConfigChange}
              />
            </Form.Group>

            <Form.Group controlId="retenciones">
              <Form.Check
                type="checkbox"
                name="retenciones"
                label="Cancelación de retenciones"
                checked={cancelacion.includes('retenciones')}
                onChange={this.handleOnCancellationConfigChange}
              />
            </Form.Group>

            <Form.Group controlId="live">
              <Form.Check
                type="checkbox"
                name="live"
                label="No soporta sandbox"
                checked={cancelacion.includes('live')}
                onChange={this.handleOnCancellationConfigChange}
              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col>
            <Form.Group controlId="registro_emisores">
              <strong>Config</strong>

              <FormControl
                as="textarea"
                label="Configuración"
                name="config"
                rows="10"
                placeholder=""
                help="Se usará en stamping pool, úsalo con precaución y evita cometer errores =)"
                value={typeof data.config === 'object' ? JSON.stringify(data.config, undefined, 4) : data.config}
                onChange={this.handleOnChange}
              />
            </Form.Group>
          </Col>
        </Row>

        {this.props.children}
      </Form>
    );
  }
}

export default PacUpsertForm;
